import React from 'react';
import S from './styles';
import dummy from '../../resources/icon.jpg';

import lee from '../../resources/a_lee.jpeg';
import lu from '../../resources/a_lu.jpeg';
import man from '../../resources/a_man.jpeg';
import red from '../../resources/a_red.jpeg';
import su from '../../resources/a_su.png';

import { SpeakerItem } from "../speaker-item"

const speakerList = [
  {
    name: '만도스',
    company: '백준 스위프트 1등',
    profile: man,
    email: 'mandos19950620@gmail.com',
    git: 'https://github.com/mandos1995',
    instagram: 'https://www.instagram.com/minseok._.good',
    summary: '휴식 중독자',
  },
  {
    name: '수박',
    company: '야곰아카데미',
    profile: su,
    email: 'soobak@yagom.net',
    git: 'https://github.com/soo941226',
    summary: '사소한 호기심이 많습니다.',
  },
  {
    name: 'RED',
    company: '슈퍼진',
    profile: red,
    email: 'seryprk@gmail.com',
    git: 'https://github.com/cherrishRed',
    blog: 'https://serynana.tistory.com',
    summary: '이것 저것 하고 있습니다.',
  },
  {
    name: '이준석',
    company: '없음',
    profile: lee,
    email: 'zime@mac.com',
    git: 'https://github.com/zime78/public',
    summary: '잡다한 일 하는 개발자 입니다.',
  },
  {
    name: '허성진(Lucas)',
    company: '인포마이닝',
    profile: lu,
    email: 'lucasheo.develop@gmail.com',
    git: 'https://github.com/heoseongjin',
    instagram: 'https://www.instagram.com/heo.010203/',
    summary: '초밥이 너무 먹고 싶습니다.',
  },
]

export const Speakers = () => (
  <S.Section>
    <S.Title
      id='speakers'
      data-sal="slide-up"
      data-sal-delay="100"
      data-sal-duration="600"
      data-sal-easing="ease"
    >
      Speakers
    </S.Title>
    <S.Wrap>
      { speakerList.map((speaker, index) => (<SpeakerItem speaker={speaker} index={index} key={speaker.name} />))}
    </S.Wrap>

  </S.Section>
)
